import script from "./UploadCSVStep2.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadCSVStep2.vue?vue&type=script&setup=true&lang=js"

import "./UploadCSVStep2.vue?vue&type=style&index=0&id=ae973718&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae973718"]])

export default __exports__